var x = {
    ghost: {
      large: {
        x: "1px",
        y: "1px"
      },
      small: {
        x: "1px",
        y: "0px"
      }
    },
    lowContrast: {
      large: {
        x: "6px",
        y: "6px"
      },
      small: {
        x: "4px",
        y: "4px"
      }
    },
    highContrast: {
      large: {
        x: "6px",
        y: "6px"
      },
      small: {
        x: "4px",
        y: "4px"
      }
    }
  },
  l = Object.assign(Object.assign({}, x), {
    getOffset: function getOffset(l, p, t) {
      var a = {
        x: "0px",
        y: "0px"
      };
      return "small" !== p && "large" !== p || (a = x[l][p]), {
        x: t && t.x ? t.x : a.x,
        y: t && t.y ? t.y : a.y
      };
    }
  });
export { l as default };